import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { getProfile, logout as logoutRequest } from '../api/apiHandler';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const refreshProfile = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getProfile({});
      if (response && parseInt(response.code) === 1) {
        setAdmin(response.data);
      } else {
        setAdmin(null);
      }
    } catch (error) {
      setAdmin(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshProfile();
  }, [refreshProfile]);

  const logout = useCallback(async () => {
    try {
      await logoutRequest({});
    } finally {
      setAdmin(null);
      window.location.href = '/authpanel/login';
    }
  }, []);

  const value = {
    admin,
    isAuthenticated: !!admin,
    isLoading,
    refreshProfile,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
